module.exports = ":host {\n  display: block; }\n\nheader {\n  background-color: #fff;\n  padding: 16px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5); }\n\nmain {\n  padding: 1em;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: center;\n  margin-top: 50px;\n  display: block; }\n\nfooter {\n  text-align: center;\n  font-size: 0.8em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 371
// module chunks = 1